import { setCountRaws } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = 0;

export default createReducer(
  [forAction(setCountRaws, identityPayload)],
  initialState,
);
